import { useObserver } from 'mobx-react-lite';
import React from 'react';
import styled, { css } from 'styled-components';

import { useStores } from '../../stores';

/**
 * Extra header is an area that is rendered directly above the header,
 * it is not available for resize and dragging, but falls under
 * the calculations of the `react-rnd` library which is also
 * responsible for window collisions.
 */
const ExtraHeader = () => {
  const { ui, config } = useStores();
  const {
    source,
    header: { avatar, height: headerHeight }
  } = config;

  // These settings are special for SPF project
  const projectName = source.split('_')[0].toLowerCase();
  const isParallelogram = projectName === 'spf';

  const avatarWidth = () => {
    if (Number(avatar.width)) {
      return avatar.width;
    }

    return avatar.height + 5;
  };

  return useObserver(() => (
    <Root minHeight={avatar.height - headerHeight}>
      <BigAvatar
        className="react-rnd-draggable-cancel"
        width={avatar.width}
        height={avatar.height}
        offset={avatar.offset}
        specialFilter={ui.isVisibleExtraHeaderFilter}
        src={avatar.url}
        alt="avatar"
      />
      {isParallelogram && (
        <Parallelogram
          height={headerHeight}
          avatarWidth={avatarWidth()}
          topPosition={avatar.height - headerHeight}
          leftPosition={avatar.offset.x}
        />
      )}
    </Root>
  ));
};

const BigAvatar = styled.img.attrs(({ width, height, offset: { x: left, y: top } }) => ({
  style: {
    width,
    height,
    left,
    top
  }
}))`
  position: absolute;
  z-index: 1;
  display: block;
  margin: 0;
  pointer-events: none;

  ${props =>
    props.specialFilter &&
    css`
      -webkit-filter: brightness(0.5);
      filter: brightness(0.5);
    `}
`;

const Root = styled.div`
  position: relative;
  height: auto;
  min-height: ${props => `${props.minHeight}px`};
  margin: 0;
`;

const Parallelogram = styled.div`
  position: absolute;
  top: ${props => props.topPosition}px;
  left: ${props => props.leftPosition - 20}px;
  width: ${props => props.avatarWidth + 80}px;
  height: ${props => props.height}px;
  background-color: #888b8d;
  transform: skew(130deg);
`;

export default ExtraHeader;
